import React from 'react';
import NewProjectWizardCard from './NewProjectWizardCard';
import styles from './css/index.module.css';

import { getCreateStep1FieldPolicy, shouldShowInvestmentType } from '../../utils/projectTypeFieldPolicy';
import DocumentContextBanner from './DocumentContextBanner';

const display = value => (value && String(value).trim() ? value : '—');

const SummaryRow = ({ label, value, first }) => (
    <div className={`${styles.summaryRow} ${first ? styles.summaryRowFirst : ''}`}>
        <span className={styles.summaryLabel}>{label}</span>
        <span className={styles.summaryValue}>{display(value)}</span>
    </div>
);

const CreateProjectStep6 = ({
    formData,
    onCreate,
    onBack,
    onEdit,
    creating,
    documentBanner,
    onDismissDocumentBanner,
    onRefreshRecommendations,
    refreshingRecommendations = false,
}) => {
    const scopes = Array.isArray(formData?.scope_areas) ? formData.scope_areas : [];
    const fieldPolicy = getCreateStep1FieldPolicy(formData?.project_type);
    const showInvestmentType = shouldShowInvestmentType(fieldPolicy) && Boolean(formData?.investment_type);

    return (
        <NewProjectWizardCard
            step={6}
            wide
            title="Review project"
            subtitle="Review the key project context before confirming the project."
            continueLabel="Confirm project"
            continueLoading={creating}
            onContinue={onCreate}
            onBack={onBack}
            backInline
        >
            {documentBanner ? (
                <DocumentContextBanner
                    variant={documentBanner}
                    onDismiss={onDismissDocumentBanner}
                    onRefresh={onRefreshRecommendations}
                    refreshing={refreshingRecommendations}
                    onNotNow={onDismissDocumentBanner}
                />
            ) : null}
            <section className={styles.summarySection}>
                <div className={styles.summaryHeader}>
                    <h2 className={styles.summaryTitle}>Project</h2>
                    <button type="button" className={styles.summaryEdit} onClick={() => onEdit(1)}>
                        Edit
                    </button>
                </div>
                <SummaryRow label="Project name" value={formData?.project_name} first />
                <SummaryRow label="Project type" value={formData?.project_type} />
                {showInvestmentType ? <SummaryRow label="Investment type" value={formData?.investment_type} /> : null}
                {fieldPolicy.showInvestor && formData?.investor_name ? (
                    <SummaryRow label={fieldPolicy.investorLabel} value={formData.investor_name} />
                ) : null}
            </section>

            <div className={styles.summaryDivider} />

            <section className={styles.summarySection}>
                <div className={styles.summaryHeader}>
                    <h2 className={styles.summaryTitle}>Organisation</h2>
                    <button type="button" className={styles.summaryEdit} onClick={() => onEdit(3)}>
                        Edit
                    </button>
                </div>
                <SummaryRow label="Organisation" value={formData?.company_name} first />
                <SummaryRow label="Sector" value={formData?.sector} />
                <SummaryRow label="Stage" value={formData?.customer_stage} />
                <SummaryRow label="Business model" value={formData?.customer_type} />
                <SummaryRow label="Company size" value={formData?.company_size} />
            </section>

            <div className={styles.summaryDivider} />

            <section className={styles.summarySection}>
                <div className={styles.summaryHeader}>
                    <h2 className={styles.summaryTitle}>Engagement</h2>
                    <button type="button" className={styles.summaryEdit} onClick={() => onEdit(5)}>
                        Edit
                    </button>
                </div>
                <div className={styles.summaryBlock}>
                    <p className={styles.summaryBlockLabel}>Engagement objective</p>
                    <p className={styles.summaryBlockValue}>{display(formData?.engagement_objective)}</p>
                </div>
                <div className={styles.summaryBlock}>
                    <p className={styles.summaryBlockLabel}>Scope areas</p>
                    {scopes.length ? (
                        <div className={styles.summaryPills}>
                            {scopes.map(area => (
                                <span key={area} className={styles.summaryPill}>
                                    {area}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <p className={styles.summaryBlockValue}>—</p>
                    )}
                </div>
            </section>
        </NewProjectWizardCard>
    );
};

export default CreateProjectStep6;
